<template>
  <div>
    <b-row class="mt-2">
      <b-col lg="3">
        <InputQuantity
          id="pIBSMun"
          label="Alíquota"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.pIBSMun"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.vIBSMun"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="IbsMunPDif"
          label="Alíquota diferimento"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.pDif"
          :precision="4"
          :returnFormattedValue="false"
          :disabled="!canEditDiferimento"
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor diferimento"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.vDif"
          :disabled="!canEditDiferimento"
        />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="3">
        <InputMoney
          label="Valor devolução tributos"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.vDevTrib"
        />
      </b-col>
      <b-col lg="3">
        <InputQuantity
          id="IbsMunPRedAliq"
          label="Percentual redução de alíquota"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.pRedAliq"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3" class="mt-lg-4">
        <InputQuantity
          id="IbsMunPAliqEfet"
          label="Alíquota efetiva"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.pAliqEfet"
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, InputQuantity } from '@/components/Form';

export default {
  name: 'IBSMun',
  components: {
    InputMoney,
    InputQuantity,
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
  },
  props: {
    canEditDiferimento: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
